"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldTariff = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Button_1 = require("../../../CheckBox/Button");
const tariffGroupMapper_1 = require("../../../TariffsTable/tariffGroupMapper");
const Wrapper_1 = require("../Wrapper");
require("./index.scss");
const className = 'form-field-tariff';
const FormFieldTariff = (props) => {
    const { value, setValue, items, info, error, modificators, required, disabled, hidden, } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    const onChange = (event) => {
        const { name } = event.target;
        const newValue = items === null || items === void 0 ? void 0 : items.find(x => `${x.id}` === name);
        setValue(newValue);
    };
    const formFieldWrapperProps = {
        label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/Field/Tariff:label', defaultMessage: 'Tariff' })),
        error,
        info,
        modificators,
        required,
        additionClassNames: className,
        inputSlot: (react_1.default.createElement("div", { className: `${className}__buttons` }, items === null || items === void 0 ? void 0 : items.map(tariffGroup => (react_1.default.createElement(Button_1.CheckBoxButton, { key: tariffGroup.id, name: `${tariffGroup.id}`, text: tariffGroup.name[locale], onChange: onChange, checked: tariffGroup.id === (value === null || value === void 0 ? void 0 : value.id), color: (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariffGroup.id) === 'business' ? 'blue' : undefined, disabled: disabled }))))),
    };
    if (hidden)
        return null;
    return (react_1.default.createElement(Wrapper_1.FormFieldWrapper, { ...formFieldWrapperProps }));
};
exports.FormFieldTariff = FormFieldTariff;
//# sourceMappingURL=index.js.map